(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/contexts/campaign-context-provider.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/contexts/campaign-context-provider.js');

'use strict';

const {
  createContext,
  useCallback,
  useEffect,
  useState
} = React;
const {
  campaign,
  productMapping
} = svs.numbergames;
const CampaignContext = createContext({});
const CampaignContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [campaigns, setCampaigns] = useState([]);
  useEffect(() => {
    (async () => {
      const campaigns = await Promise.all([productMapping.CONSTANTS.KENO, productMapping.CONSTANTS.LOTTO].map(product => campaign.getCampaign({
        product
      })));
      setCampaigns(campaigns.filter(Boolean));
    })();
  }, []);
  const getActiveCampaign = useCallback((productNumeric, drawNumber) => {
    var _campaigns$find;
    return campaigns === null || campaigns === void 0 || (_campaigns$find = campaigns.find) === null || _campaigns$find === void 0 ? void 0 : _campaigns$find.call(campaigns, campaign => {
      var _campaign$products, _campaign$products$fi;
      return (_campaign$products = campaign.products) === null || _campaign$products === void 0 || (_campaign$products$fi = _campaign$products.find) === null || _campaign$products$fi === void 0 ? void 0 : _campaign$products$fi.call(_campaign$products, product => product.productId === productNumeric && product.startDrawNumber <= drawNumber && product.endDrawNumber >= drawNumber);
    });
  }, [campaigns]);
  const hasActiveCampaign = useCallback((productNumeric, drawNumber) => !productMapping.isLotto(productNumeric) && Boolean(getActiveCampaign(productNumeric, drawNumber)), [getActiveCampaign]);
  const getCampaignChances = useCallback(_ref2 => {
    let {
      productNumeric,
      drawNumber,
      totalPrice,
      game
    } = _ref2;
    return (
      getActiveCampaign(productNumeric, drawNumber) ? (parseInt(totalPrice, 10) - game.jokerPrice) / game.rowPrice : 0
    );
  }, [getActiveCampaign]);
  const getCampaignInfo = useCallback((productNumeric, drawNumber) => {
    var _getActiveCampaign;
    return (_getActiveCampaign = getActiveCampaign(productNumeric, drawNumber)) !== null && _getActiveCampaign !== void 0 ? _getActiveCampaign : {};
  }, [getActiveCampaign]);
  return React.createElement(CampaignContext.Provider, {
    value: {
      hasActiveCampaign,
      getCampaignInfo,
      getCampaignChances
    }
  }, children);
};
Object.assign(svs.numbergames.fractiongames.contexts, {
  CampaignContext,
  CampaignContextProvider
});

 })(window);